import { townsperson } from './content.js';
import { SNOW_DRAGON_QUESTS } from './snow-dragon.js';
import { SNOW_QUESTS } from './snow-quests.js';
/**
 * The quests of the Pics Gelés (ADR 0047), the last region: the chain that
 * starts with Jarl Haldor (`jarl`), on the square of Givrecime, and ends
 * with the Frost Giant's fall, what it sets loose under the ice (La Brèche,
 * ADR 0067) and the tale carried back to Havrebourg. The quests are in
 * `snow-quests.ts` and `snow-dragon.ts`; here, the townsfolk they need,
 * where they stand, the baits, and the experience of the region's creatures
 * once the chain pays the rest. See `content.ts`.
 */
/** The townsfolk only this region's quests need, added to the bestiary. */
export const SNOW_NPC_IDS = [
    'jarl',
    'snow-skald',
    'snow-seer',
    'snow-huntress',
    'snow-scout',
    'snow-warden',
];
export const SNOW = {
    quests: [...SNOW_QUESTS, ...SNOW_DRAGON_QUESTS],
    npcs: {
        jarl: townsperson('jarl', 'Jarl Haldor'),
        'snow-skald': townsperson('snow-skald', 'Skalde Runa'),
        'snow-seer': townsperson('snow-seer', 'Voyante Eira'),
        'snow-huntress': townsperson('snow-huntress', 'Chasseuse Sigrun'),
        'snow-scout': townsperson('snow-scout', 'Éclaireur Torvald'),
        'snow-warden': townsperson('snow-warden', 'Vieil Ulfar'),
    },
    keepers: [
        // The skald sings by the longhouse, a few steps off the square.
        { mob: 'snow-skald', near: 'Givrecime', dx: -5, dy: 3 },
        { mob: 'snow-seer', near: 'Cristaux du Givre', dx: 2, dy: 3 },
        { mob: 'snow-huntress', near: "Caverne de l'Ours", dx: -3, dy: 4 },
        { mob: 'snow-scout', near: 'Crête du Givre', dx: 0, dy: 5 },
        // Ulfar keeps watch on the fortress' esplanade, never inside.
        { mob: 'snow-warden', near: 'Trône de Givre', dx: -5, dy: 4 },
        // Each player's own quarry at La Brèche (ADR 0087): no den lies near it.
        {
            mob: 'frost-revenant',
            near: 'La Brèche',
            dx: 0,
            dy: 0,
            count: 5,
            radius: 5,
            during: 'snow-breach',
        },
    ],
    items: [
        {
            id: 'frost-honey',
            name: 'Rayon de miel givré',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.frost-honey',
            lootable: false,
            bait: { summons: 'ice-bear', den: 'polar-bear' },
        },
        {
            id: 'howl-horn',
            name: 'Corne des hurlements',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.howl-horn',
            lootable: false,
            bait: { summons: 'howling-yeti', den: 'yeti' },
        },
        {
            id: 'storm-orb',
            name: 'Orbe de tempête',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.storm-orb',
            lootable: false,
            bait: { summons: 'elder-blizzard', den: 'yeti' },
        },
    ],
    // A little over half the bestiary's figures (ADR 0047): the chain pays 40 % of
    // the band, and the audit keeps the region longer with it than it was without.
    xp: { 'ice-wolf': 47, 'polar-bear': 50, 'snow-harpy': 53, 'frost-revenant': 56, yeti: 61 },
    greetings: {
        jarl: 'Il reste un peu de bière, si tu veux. Pas beaucoup, Torvald est passé.',
        'snow-skald': 'Tu n’aurais pas un bout de pain, par hasard ?',
        'snow-seer': 'La glace est toute claire ce soir. Je n’aime pas quand elle est trop claire.',
        'snow-huntress': 'Toujours neuf doigts et demi ? Fais attention aux autres !',
        'snow-scout': 'Tu restes un peu ? Allez, reste un peu, j’ai plein d’histoires à raconter !',
        'snow-warden': 'Vingt ans devant cette porte. J’ai compté chaque nuit. Il y en a eu beaucoup.',
    },
};
//# sourceMappingURL=snow.js.map